import React from "react";

export const MACHINE_FUEL_ALERT_HELP_TITLE =
  "Combustível — tanque e consumo para alertas";

export function MachineFuelAlertHelpContent({ meterType = "hour_meter" }) {
  const usesHour = meterType === "hour_meter" || meterType === "both";
  const usesKm = meterType === "odometer" || meterType === "both";

  return (
    <>
      <p>
        <strong>Para que serve?</strong> Estes dados permitem que a plataforma
        analise cada <strong>abastecimento</strong> enviado pelo app e gere
        alertas automáticos quando algo não bater com o cadastro da máquina.
      </p>

      <p>
        <strong>Capacidade do tanque (L)</strong> — volume máximo que o tanque
        comporta. Ex.: caminhão com tanque de 400 L.
      </p>
      <ul>
        <li>
          Alerta se o operador informar <strong>mais litros</strong> do que a
          capacidade;
        </li>
        <li>
          Alerta se marcar <strong>tanque cheio</strong> e a soma do abastecimento
          anterior com o atual, descontado o <strong>consumo mínimo</strong> no
          intervalo (parada ou horímetro), ultrapassar a capacidade — a plataforma
          não deduz quanto havia no tanque antes.
        </li>
      </ul>

      {usesHour ? (
        <>
          <p>
            <strong>Consumo mínimo e máximo (L/h)</strong> — faixa esperada de
            consumo por <strong>hora de horímetro</strong> entre abastecimentos.
            Ex.: entre 8 L/h e 18 L/h para um trator médio.
          </p>
          <ul>
            <li>
              A plataforma calcula: litros abastecidos ÷ horas de horímetro desde
              o registro anterior;
            </li>
            <li>
              Se ficar <strong>acima do máximo</strong> → possível erro de
              litros, fraude ou máquina com problema;
            </li>
            <li>
              Se ficar <strong>abaixo do mínimo</strong> → abastecimento parcial
              suspeito ou leitura errada.
            </li>
          </ul>
        </>
      ) : null}

      {usesKm ? (
        <>
          <p>
            <strong>Rendimento mínimo e máximo (km/L)</strong> — faixa esperada
            de <strong>quilômetros por litro</strong> entre abastecimentos.
            Ex.: entre 2,5 km/L e 6 km/L para um caminhão.
          </p>
          <ul>
            <li>
              A plataforma calcula: quilômetros percorridos ÷ litros abastecidos
              desde o registro anterior;
            </li>
            <li>
              Se ficar <strong>abaixo do mínimo</strong> → consumo alto demais
              (poucos km por litro);
            </li>
            <li>
              Se ficar <strong>acima do máximo</strong> → rendimento
              improvável — conferir hodômetro ou litros informados.
            </li>
          </ul>
        </>
      ) : null}

      <p>
        <strong>Medidor no abastecimento</strong> — também comparamos a leitura
        com o histórico (mesmas regras de leitura inconsistente: valor menor que
        o anterior, salto grande, etc.).
      </p>
      <ul>
        <li>
          Alerta se houver <strong>novo abastecimento</strong> mas o horímetro ou
          hodômetro <strong>não avançou</strong> desde o registro anterior — indica
          consumo de combustível sem horas ou quilometragem registradas.
        </li>
      </ul>

      <p>
        <strong>Onde aparecem os alertas?</strong> Em{" "}
        <strong>Ações pendentes e alertas</strong>, na seção{" "}
        <strong>Abastecimento inconsistente</strong>. O gestor pode reconhecer
        ou dispensar após conferir com o operador.
      </p>

      <p>
        <strong>App de campo — no abastecimento</strong> — regras de captura
        quando o operador registra um abastecimento:
      </p>
      <ul>
        <li>
          A <strong>leitura manual</strong> do horímetro ou hodômetro é sempre
          obrigatória;
        </li>
        <li>
          <strong>Foto do medidor</strong> — opcional por máquina; quando
          marcada, o app solicita foto junto com a leitura;
        </li>
        <li>
          <strong>Foto do marcador de combustível</strong> — nível do tanque no
          momento do abastecimento;
        </li>
        <li>
          <strong>Foto do abastecimento</strong> — bomba, nota fiscal ou
          comprovante;
        </li>
        <li>
          <strong>Hectares</strong> — informar valor do contador;{" "}
          <strong>foto dos hectares</strong> — opcional, independente de exigir
          o valor numérico.
        </li>
      </ul>

      <p>
        Campos em branco desativam aquela regra — por exemplo, sem capacidade
        cadastrada a plataforma não alerta litros acima do tanque.
      </p>
    </>
  );
}
